import { createContext } from 'react';

export const NotifContext = createContext(null);
